<template>
    <div class="bottom-cta">
        <h2>What would you want to do next?</h2>
        <div class="flex-container">
            <div class="bot-btn-container" id="first">
                <h3>Take a moment and read the Primer!</h3>
                <button @click="$router.push('/Primer')" class="primary-btn home-ctas">Learn more</button>
            </div>

            <div class="bot-btn-container" id="second">
                <h3>I'm ready to be a Wave 2 Officer!</h3>
                <button @click="$router.push('/apply')" class="primary-btn home-ctas">Apply now</button>
            </div>

        </div>
    </div>
</template>

<script>
export default {
    name: 'BottomCTA'
}
</script>

<style scoped>
    .flex-container{
        display: flex;
        flex-flow: row wrap;
        justify-content: flex-start;
    }

    #first{
        margin-right: 179px;
    }

    #second{
        padding-bottom: 64px;
    }

    .bottom-cta{
        padding-top: 10vh;
        padding-bottom: 64px;
    }

</style>
